"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var FormatBold_exports = {};
__export(FormatBold_exports, {
  default: () => FormatBold_default
});
module.exports = __toCommonJS(FormatBold_exports);
var React = __toESM(require("react"));
var import_styled_components = __toESM(require("styled-components"));
const SvgIcon = ({
  title,
  titleId,
  desc,
  descId,
  iconSize,
  ariaHidden,
  ...props
}) => /* @__PURE__ */ React.createElement(
  "svg",
  {
    ...props,
    viewBox: "0 0 21 20",
    fill: "currentColor",
    color: "currentColor",
    role: "img",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  },
  desc ? /* @__PURE__ */ React.createElement("desc", { id: descId }, desc) : null,
  title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null,
  /* @__PURE__ */ React.createElement(
    "path",
    {
      d: "M13.5078 10.0742C13.9115 9.80078 14.237 9.45573 14.4844 9.03906C14.7448 8.60938 14.875 8.17969 14.875 7.75C14.875 6.8125 14.5495 6.02474 13.8984 5.38672C13.2604 4.73568 12.4727 4.41016 11.5352 4.41016H6.33984V16.0898H12.1992C13.0716 16.0898 13.8008 15.7839 14.3867 15.1719C14.9857 14.5469 15.2852 13.7982 15.2852 12.9258C15.2852 12.2878 15.1224 11.7148 14.7969 11.207C14.4714 10.6992 14.0417 10.3216 13.5078 10.0742ZM8.83984 6.5H11.3398C11.6784 6.5 11.9714 6.6237 12.2188 6.87109C12.4661 7.10547 12.5898 7.39844 12.5898 7.75C12.5898 8.10156 12.4661 8.40104 12.2188 8.64844C11.9714 8.88281 11.6784 9 11.3398 9H8.83984V6.5ZM11.75 14H8.83984V11.5H11.75C12.1016 11.5 12.3945 11.6237 12.6289 11.8711C12.8763 12.1055 13 12.3984 13 12.75C13 13.1016 12.8763 13.401 12.6289 13.6484C12.3945 13.8828 12.1016 14 11.75 14Z",
      fill: "currentColor"
    }
  )
);
const SvgFormatBold = (0, import_styled_components.default)(SvgIcon)(({ iconSize, color }) => {
  const getIconSize = () => {
    const standardIconSize = {
      s: "17px",
      // 17px small
      m: "20px",
      // 20px medium
      l: "24px",
      // 24px large
      xl: "32px",
      // 32px extraLarge
      inherit: "inherit"
      // inherits size from parent
    };
    return standardIconSize[iconSize];
  };
  return import_styled_components.css`
    width: ${getIconSize()};
    height: ${getIconSize()};
    display: inline-block;
    color: ${color};
  `;
});
var FormatBold_default = SvgFormatBold;
